import React from "react";
import { useNavigate } from "react-router-dom";
import placeholderImg from "../../img/accueil_concept4.png";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  const d = new Date(Number(year), Number(month) - 1, Number(day));
  return d.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const EventCard = ({ evenement }) => {
  const navigate = useNavigate();
  const { evenement_id, nom, sous_titre, photo, periodes = [] } = evenement;

  const prochainePeriode = periodes.find((p) => p.disponible) ?? periodes[0];
  const dateLabel = prochainePeriode?.date ? formatDate(prochainePeriode.date) : null;

  const imageUrl = photo || placeholderImg;

  const excerpt =
    sous_titre && sous_titre.length > 130
      ? sous_titre.slice(0, 130).trimEnd() + "…"
      : sous_titre;

  return (
    <article
      onClick={() => navigate(`/agenda/evenement/${evenement_id}`)}
      className="bg-white rounded-2xl shadow-md overflow-hidden cursor-pointer transform transition-all duration-300 hover:scale-[1.03] hover:shadow-xl flex flex-col"
    >
      <div className="relative w-full h-52 overflow-hidden flex-shrink-0">
        <img
          src={imageUrl}
          alt={nom}
          className="w-full h-full object-cover"
        />
        {dateLabel && (
          <span className="absolute top-3 left-3 bg-orange-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow">
            {dateLabel}
          </span>
        )}
      </div>

      <div className="p-5 flex flex-col flex-grow">
        <h3 className="text-lg font-bold text-slate-900 mb-2 leading-snug">
          {nom}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed flex-grow">
          {excerpt}
        </p>
        <span className="mt-4 inline-block text-orange-600 text-sm font-semibold hover:text-orange-800 transition-colors">
          Voir l'événement →
        </span>
      </div>
    </article>
  );
};

export default EventCard;
